import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "value",
      description: "绑定值",
      type: "string / number"
    },
    {
      prop: "label",
      description: "上放标签",
      type: "String"
    },

    {
      prop: "iconClass",
      description: "icon类",
      type: "String"
    },
    {
      prop: "disabled",
      description: "是否禁用",
      type: Boolean,
      default: "false"
    }
  ],
  events: [],
  methods: [],
  slots: [
    {
      name: "label",
      description: "自定义label"
    }
  ]
};

export default DemoWrapper(Demo, DemoSource, config);
